import { z } from 'zod';

export const tourConsentSchema = z.object({
  displayName: z
    .string()
    .min(1, 'Nazwa wyświetlana jest wymagana')
    .max(255, 'Nazwa może mieć maksymalnie 255 znaków'),
  consentTemplateId: z.string().min(1, 'Szablon zgody jest wymagany'),
  required: z.boolean().default(false),
  shouldSendDocumentToClient: z.boolean().default(false),
});

export type TourConsentFormData = z.infer<typeof tourConsentSchema>;
export type TourConsentInputData = z.input<typeof tourConsentSchema>;
